import React, { useMemo, useState } from 'react';
import { CornerDownRight, LineChart, X } from 'lucide-react';
import { decoupeReponse } from './blocs';
import { ChatMessage } from '../../types/chat';

interface PistesDeSuiteProps {
  messages: ChatMessage[];
  isLoading: boolean;
  onChoisir: (question: string) => void;
}

// Pistes de suite construites par le serveur (api/app/nia_outils/suites.py), pour la
// DERNIÈRE réponse seulement. Affichées juste au-dessus de la saisie, donc toujours
// visibles même sous un long graphique ; elles se ferment d'un clic et ne bloquent
// jamais la saisie (cf. docs/nia_interface/).
export const PistesDeSuite: React.FC<PistesDeSuiteProps> = ({ messages, isLoading, onChoisir }) => {
  const dernier = messages[messages.length - 1];
  const [fermeePour, setFermeePour] = useState<string | null>(null);
  const pistes = useMemo(
    () => (dernier && dernier.role === 'assistant' && !dernier.isLoading ? decoupeReponse(dernier.content).pistes : []),
    [dernier],
  );

  if (isLoading || pistes.length === 0 || fermeePour === dernier.id) return null;

  return (
    <div className="pistes-suite" role="group" aria-label="Pistes pour continuer">
      <div className="pistes-suite-entete">
        <span>Pour aller plus loin, je peux aussi :</span>
        <button type="button" className="message-action" onClick={() => setFermeePour(dernier.id)} aria-label="Masquer les pistes">
          <X size={13} />
        </button>
      </div>
      <div className="pistes-suite-liste">
        {pistes.map((p) => (
          <button key={p.label} type="button" className="piste-suite" onClick={() => onChoisir(p.label)}>
            {p.kind === 'chart' ? <LineChart size={14} aria-hidden="true" /> : <CornerDownRight size={14} aria-hidden="true" />}
            <span>{p.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
